<template>
  <VueSelect
    v-bind="$attrs"
    :value="value"
    :options="opcoesComCadastroRapido"
    :label="label"
    :filterable="false"
    :disabled="disabled || creating"
    :loading="searching || creating"
    @input="onInput"
    @search="onSearch"
  >
    <template slot="no-options">
      <slot name="no-options">Digite para pesquisar</slot>
    </template>

    <template slot="option" slot-scope="option">
      <div v-if="option.__cadastroRapido" class="cadastro-rapido-option">
        <span class="cadastro-rapido-option__icon">+</span>
        <span>Criar {{ entityLabel }} “{{ option[label] }}”</span>
      </div>
      <slot v-else name="option" v-bind="option">
        {{ option[label] }}
      </slot>
    </template>

    <template slot="selected-option" slot-scope="option">
      <slot name="selected-option" v-bind="option">
        {{ option[label] }}
      </slot>
    </template>
  </VueSelect>
</template>

<script>
import VueSelect from "vue-select";

export default {
  name: "app-cadastro-rapido-select",
  inheritAttrs: false,
  components: {
    VueSelect,
  },
  props: {
    value: {
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "nome",
    },
    entityLabel: {
      type: String,
      required: true,
    },
    creating: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    minCreateLength: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      searchTerm: "",
      searching: false,
    };
  },
  computed: {
    opcoesComCadastroRapido() {
      const opcoes = Array.isArray(this.options) ? this.options : [];
      const nome = this.searchTerm.trim();

      if (
        nome.length < this.minCreateLength ||
        this.searching ||
        this.creating
      ) {
        return opcoes;
      }

      const nomeNormalizado = this.normalizar(nome);
      const opcaoExistente = opcoes.some(
        (opcao) => this.normalizar(opcao?.[this.label]) === nomeNormalizado
      );

      if (opcaoExistente) {
        return opcoes;
      }

      return [
        ...opcoes,
        {
          __cadastroRapido: true,
          [this.label]: nome,
        },
      ];
    },
  },
  methods: {
    normalizar(value) {
      return String(value || "")
        .trim()
        .toLocaleLowerCase("pt-BR");
    },
    onInput(option) {
      if (option?.__cadastroRapido) {
        this.$emit("create", option[this.label]);
        return;
      }

      this.searchTerm = "";
      this.$emit("input", option);
    },
    onSearch(search, toggleLoading) {
      this.searchTerm = search || "";
      this.searching = false;

      this.$emit("search", search, (value) => {
        this.searching = Boolean(value);
        toggleLoading(value);
      });
    },
  },
};
</script>

<style src="vue-select/dist/vue-select.css"></style>

<style>
.cadastro-rapido-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #3699ff;
  font-weight: 500;
}

.cadastro-rapido-option__icon {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}

.vs__dropdown-option--highlight .cadastro-rapido-option {
  color: #fff;
}
</style>
